import { Box, Flex, TextV2 } from '@withjoy/joykit';
import React from 'react';

const PURPLE_BLUE_COLOR = '#4951EF';

interface ValuePropsSectionProps {
  items: Array<{
    title: string;
    description: string;
    icon: () => JSX.Element;
  }>;
}

export const ValuePropsSection = (props: ValuePropsSectionProps) => {
  const { items } = props;

  return (
    <Flex marginTop={6} borderRadius={4} border={`2px solid ${PURPLE_BLUE_COLOR}`} rowGap={6} padding={6} flexDirection="column">
      {items.map(vp => (
        <Flex key={vp.title} columnGap={5} alignItems="center">
          <Box color={PURPLE_BLUE_COLOR}>{vp.icon()}</Box>
          <Flex flexDirection="column">
            <TextV2 typographyVariant="body2" fontWeight={600}>
              {vp.title}
            </TextV2>
            <TextV2 typographyVariant="body1">{vp.description}</TextV2>
          </Flex>
        </Flex>
      ))}
    </Flex>
  );
};
